import React from "react";
var InternalIcon = /*#__PURE__*/React.createElement("svg", {
  width: "17",
  height: "15",
  viewBox: "0 0 17 15",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, /*#__PURE__*/React.createElement("path", {
  d: "M0.78125 8.125C0.375 7.4375 0.375 6.59375 0.78125 5.875L3.53125 1.125C3.9375 0.40625 4.6875 0 5.46875 0H11C11.8125 0 12.5312 0.40625 12.9375 1.125L15.6875 5.875C16.0938 6.59375 16.0938 7.4375 15.6875 8.125L12.9375 12.9062C12.5312 13.625 11.8125 14.0312 11 14.0312H5.46875C4.6875 14.0312 3.9375 13.625 3.53125 12.9062L0.78125 8.125ZM8.25 3C7.8125 3 7.5 3.34375 7.5 3.75V7.25C7.5 7.6875 7.8125 8 8.25 8C8.65625 8 9 7.6875 9 7.25V3.75C9 3.34375 8.65625 3 8.25 3ZM9.25 10C9.25 9.46875 8.78125 9 8.25 9C7.6875 9 7.25 9.46875 7.25 10C7.25 10.5625 7.6875 11 8.25 11C8.78125 11 9.25 10.5625 9.25 10Z",
  fill: "#DC0A0A"
}));
export default InternalIcon;